import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";
import {MinutosGraciaModel} from "../model/minutoGracia.model";


@Injectable({
  providedIn: 'root'
})
export class ParametrizacionMinutosGraciaService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.parametrizacion.minutosGracia.getAll);
  }

  actualizarMinutosGracia(minutosGracia: MinutosGraciaModel) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.parametrizacion.minutosGracia.update + minutosGracia.id + '', minutosGracia);
  }

}
